import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { toast } from "sonner";
import { EMBLEM_URL, NAV_LINKS } from "@/data/content";

const Footer = () => {
  const [email, setEmail] = useState("");

  const submit = (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    toast.success("Transmission received. The Forge will respond.");
    setEmail("");
  };

  return (
    <footer data-testid="site-footer" className="relative overflow-hidden border-t border-[#282D37] bg-[#0A0B0D]">
      <div
        className="pointer-events-none absolute inset-0"
        style={{
          background:
            "radial-gradient(ellipse 60% 45% at 50% 110%, rgba(229,46,46,0.09) 0%, transparent 70%)",
        }}
      />
      <div className="relative mx-auto max-w-[1400px] px-6 pb-10 pt-20 lg:px-10">
        <div className="grid gap-14 lg:grid-cols-[1.4fr_1fr_1fr_1.4fr]">
          <div>
            <div className="flex items-center gap-3">
              <img src={EMBLEM_URL} alt="Arsenal Forge emblem" className="w-10" />
              <span className="font-display text-xl font-bold uppercase tracking-[0.25em]">
                Arsenal <span className="text-[#E52E2E]">Forge</span>
              </span>
            </div>
            <p className="mt-6 max-w-xs text-sm leading-relaxed text-[#9EA4B0]">
              Independent game development studio. Small team. Big worlds. Forged with intent.
            </p>
          </div>

          <div>
            <p className="font-mono text-xs tracking-[0.3em] text-[#5F6573]">NAVIGATE</p>
            <ul className="mt-6 space-y-3">
              {[{ label: "HOME", to: "/" }, ...NAV_LINKS].map((l) => (
                <li key={l.to + l.label}>
                  <Link
                    to={l.to}
                    data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                    className="text-sm text-[#9EA4B0] transition-colors duration-300 hover:text-[#E52E2E]"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="font-mono text-xs tracking-[0.3em] text-[#5F6573]">CHANNELS</p>
            <ul className="mt-6 space-y-3">
              {[
                { label: "DISCORD", href: "https://discord.gg/TheArsenal" },
                { label: "TERRITORIA WIKI", href: "https://territoria.wiki" },
                { label: "ARSENAL SERVERS", href: "https://arsenalservers.co" },
                { label: "YOUTUBE", href: "#" },
              ].map((s) => (
                <li key={s.label}>
                  <a
                    href={s.href}
                    target={s.href.startsWith("http") ? "_blank" : undefined}
                    rel="noreferrer"
                    data-testid={`footer-social-${s.label.toLowerCase().replace(/[\s/]+/g, "-")}`}
                    className="text-sm text-[#9EA4B0] transition-colors duration-300 hover:text-[#E52E2E]"
                  >
                    {s.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="font-mono text-xs tracking-[0.3em] text-[#5F6573]">TRANSMISSIONS</p>
            <p className="mt-6 text-sm leading-relaxed text-[#9EA4B0]">
              Studio dispatches and Territoria milestones. Depth over frequency.
            </p>
            <form onSubmit={submit} className="mt-5 flex border border-[#282D37]">
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="EMAIL ADDRESS"
                data-testid="footer-newsletter-input"
                className="w-full bg-transparent px-4 py-3 font-mono text-xs tracking-widest text-[#F4F5F7] placeholder-[#5F6573] outline-none"
              />
              <button
                type="submit"
                data-testid="footer-newsletter-submit"
                className="flex items-center gap-2 bg-[#E52E2E] px-5 font-mono text-xs font-bold tracking-widest text-white transition-colors duration-300 hover:bg-[#FF3B3B]"
                aria-label="Subscribe"
              >
                <ArrowRight size={16} />
              </button>
            </form>
          </div>
        </div>

        <div className="mt-20 select-none overflow-hidden">
          <p className="text-stroke whitespace-nowrap text-center font-display text-[9vw] font-black uppercase leading-none opacity-40">
            ARSENAL FORGE
          </p>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-4 border-t border-[#282D37]/70 pt-8 sm:flex-row">
          <p className="font-mono text-[11px] tracking-[0.25em] text-[#5F6573]">
            © 2026 ARSENAL FORGE. ALL WORLDS RESERVED.
          </p>
          <p className="font-mono text-[11px] tracking-[0.25em] text-[#5F6573]">
            STATUS: <span className="text-[#E52E2E]">FORGE ACTIVE</span>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
